import React from 'react';
import { equals, map, prop } from 'ramda';
import { Link, useLocation, withRouter } from 'react-router-dom';
import classNames from 'classnames';

const MenuLayout = ({ title, menuItems, match, children }) => {
  const { pathname } = useLocation();
  const matchUrl = prop('url', match);

  return (
    <div class="flex">
      <aside class="w-[256px] fixed h-full bg-white">
        <h2 class="p-6 text-2xl font-bold">
          {title}
        </h2>
        <nav class="py-4">
          <ul class="space-y-2">
            {
              map(({ label, icon, path }) => {
                const linkPath = `${matchUrl}${path}`;
                const isActive = equals(pathname, linkPath);
                return (
                  <li><Link to={linkPath} class={classNames('block p-2 !pl-[25px] font-medium text-flexi-logo hover:text-flexi-primary-color', { 'bg-flexi-info-toaster text-flexi-primary-color': isActive })}>{icon}{label}</Link></li>
                );
              }, menuItems)
            }
          </ul>
        </nav>
      </aside>

      <main class="flex-1 ml-[256px] w-[calc(100%-256px)] bg-flexi-blue-bg p-8">
        {children}
      </main>
    </div>
  );
};

export default withRouter(MenuLayout);